export enum DeliveryType {
	DeliveryToAddress = "DeliveryToAddress",
	Online = "Online",
	PickUpCakovice = "PickUpCakovice",
	PickUpCentral = "PickUpCentral",
	PickUpPetriny = "PickUpPetriny",
}
